/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable promise/always-return */
/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
/* eslint-disable unicorn/no-useless-undefined */
/* eslint-disable unicorn/no-array-for-each */
import { render } from 'lit-html';
import Modal from '../../components/Modal';
import BankCards from '../../components/BankCards';
import SelectorEngine from '../../utils/dom/selector-engine';
import Request from '../../utils/request';
import attachValidation from '../../utils/form-validation';
import { scrollToTop, getDataFromForm } from '../../utils/misc';
import { packagesSummaryTemplate } from '../MembershipOnboarding/membership-cards-templates';
import dataLayer from '../../utils/data-layer';
import { getCookie } from '../../utils/cookiesManager';

class AccountDetailsMembershipCheckout {
	constructor() {
		this.state = {
			selectedPlan: undefined
		};
		this._wrapper = undefined;
		this._paymentValidation = undefined;
		this._submitBtn = undefined;
		this._successModal = undefined;
		this._processingModal = undefined;
		this._bankCards = undefined;
		this.analyticsCookie = undefined;

		this.initiateCheckout();
	}

	initiateCheckout() {
		this._wrapper = SelectorEngine.findOne('.p-account-details-membership-checkout');

		if (this._wrapper !== null) {
			this.getAnalyticsCookie();
			this._submitBtn = SelectorEngine.findOne('.js-membership-update', this._wrapper);

			const backButton = SelectorEngine.findOne('.js-account-membership-checkout-back', this._checkoutWrapper);
			backButton.addEventListener('click', this.redirectToUrl);

			const dismissError = SelectorEngine.findOne('.js-dismiss-submit-error', this._wrapper);
			dismissError.addEventListener('click', () => {
				const errorPopup = document.querySelector('.lta-onboarding-submit--error');
				errorPopup.classList.add('u-hidden');
			});

			this._successModal = new Modal(SelectorEngine.findOne('#success-payment'), { backdrop: 'static' });
			const successCtas = SelectorEngine.find('.js-payment-success', this._wrapper);
			successCtas.forEach((cta) => {
				cta.addEventListener('click', this.redirectToUrl);
			});

			this._processingModal = new Modal(SelectorEngine.findOne('#processing-payment'), { backdrop: 'static' });
			const processingCtas = SelectorEngine.find('.js-payment-processing', this._wrapper);
			processingCtas.forEach((cta) => {
				cta.addEventListener('click', this.redirectToUrl);
			});

			this._bankCards = new BankCards('.js-bank-cards-membership');

			this._wrapper.addEventListener('cards', this.handleCardChange.bind(this));

			this.getPackageInfo();
			this.validatePaymentForm();
		}
	}

	getAnalyticsCookie() {
		let myCookie = getCookie('cookieprefs');
		let decodedStr = decodeURIComponent(myCookie);
		let jsonObject = JSON.parse(decodedStr);

		const perfCookie = jsonObject.perf;
		this.analyticsCookie =  perfCookie == true ? 'granted' : 'denied';
	}

	redirectToUrl(event, eventUrl = undefined) {
		const rootUrl = window.location.origin;
		const url = eventUrl || event.currentTarget.dataset.target;
		window.location.href = `${rootUrl}${url}`;
	}

	async getPackageInfo() {
		const membershipId = sessionStorage.getItem('checkout-id');

		//TODO show error if no id
		if (!membershipId) {
			this.showError('We have issues loading your cart.');
			return;
		}

		const packageResponse = await Request.get(`/api/account/membership/${membershipId}`).catch(() => {
			this.showError('We have issues loading your cart.');
			scrollToTop();
		});

		if (packageResponse && packageResponse.statusCode === '02') {
			this.state.selectedPlan = packageResponse.Membership;

			const membershipTotal = SelectorEngine.findOne('.js-package-total', this._wrapper);
			membershipTotal.innerHTML = this.state.selectedPlan.DisplayPrice;

			const packagesWrapper = SelectorEngine.findOne('.lta-membership-checkout--summary-packages', this._wrapper);
			const packagesTemplate = packagesSummaryTemplate(this.state.selectedPlan, false, []);
			render(packagesTemplate, packagesWrapper);

			this._submitBtn.disabled = false;
		} else {
			this.showError('We have issues loading your cart.');
			scrollToTop();
		}
	}

	handleCardChange(event) {
		this._submitBtn.disabled = !event.detail.hasCards;
	}

	showError(title) {
		const errorPopup = document.querySelector('.lta-onboarding-submit--error');
		const popupTitle = SelectorEngine.findOne('.title', errorPopup);
		popupTitle.innerHTML = title;
		errorPopup.classList.remove('u-hidden');
		scrollToTop();
	}

	validatePaymentForm() {
		const paymentForm = SelectorEngine.findOne('#amend-membership-checkout');
		const cardValidators = {
			validators: {
				notEmpty: {
					message: 'Please select one payment option below, or alternatively add a new payment type'
				}
			}
		};
		paymentForm.addEventListener('addCard', (event) => this.addFieldToValidation(event, cardValidators));
		this._paymentValidation = attachValidation(paymentForm, {
			CardTokenId: cardValidators
		});

		this._paymentValidation.on('core.form.valid', async () => {
			this._bankCards.showCards();
			const dataObject = getDataFromForm(paymentForm);

			if (dataObject.CardTokenId) {
				this._submitBtn.disabled = true;
				const paymentRequest = await Request.post('/api/payments/pay', {
					Customer: {
						CustomerId: dataObject.CustomerId
					},
					OrderTotal: this.state.selectedPlan.Price,
					LineItems: [
						{
							ProductId: this.state.selectedPlan.SalesForceId
						}
					],
					PaymentMethod: {
						CardTokenId: dataObject.CardTokenId,
						RecurringPayment: true,
						RetainCard: true
					}
				}).catch(() => {
					this._submitBtn.disabled = false;
					this.showError('We have had an error processing your payment');
				});

				switch (paymentRequest.Status) {
					case 'SUCCEEDED':
						dataLayer.push({
							event: 'membership-upgrade',
							existingMembership: sessionStorage.getItem('existing-membership-id'),
							upgradedMembership: this.state.selectedPlan.Name,
							analytics_storage: this.analyticsCookie
						});
						this._successModal.show();
						break;
					case 'PROCESSING':
						this._processingModal.show();
						break;
					case 'REQ_AUTHORIZATION':
						// eslint-disable-next-line no-case-declarations
						const { paymentIntent, error } = await this._bankCards._stripeLTA
							.confirmCardPayment(paymentRequest.ClientSecret)
							.catch(() => {
								this.showError('We were unable to confirm your card payment.', false);
							});

						if (error) {
							this._bankCards.showError(error.message, false);
							this._submitBtn.disabled = false;
							const cancelPayment = await this._bankCards.captureCardPayment(error.payment_intent.id);
						} else {
							const capturePayment =  await this._bankCards.captureCardPayment(paymentIntent.id)
							.then((response) => {
								if(response.Status) {
									this._successModal.show();
								} else {
									this.showError('We were unable to confirm your card payment.', false);
									this._submitBtn.disabled = false;
								}			
							}).catch(() => {
								this.showError('We were unable to confirm your card payment.', false);
								this._submitBtn.disabled = false;
							});
						}
					  break;
					default:
						this.showError(paymentRequest.ErrorMessage);
						this._submitBtn.disabled = false;
				}
			}
		})
	}



	addFieldToValidation(event, validators) {
		this._paymentValidation
			.addField('CardTokenId', validators)
			.resetField('CardTokenId', true);
	}
}

const globalAccountMembershipCheckout = new AccountDetailsMembershipCheckout();

export default globalAccountMembershipCheckout;
